import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCsvColumnsMutationVariables = Types.Exact<{
  url: Types.Scalars['String']['input'];
}>;


export type GetCsvColumnsMutation = { __typename?: 'Mutation', getCsvColumns: { __typename?: 'GetCsvColumnsMutationResult', success: boolean, error?: { __typename?: 'Error', message?: string | null } | null, columns?: Array<{ __typename?: 'CsvColumn', name: string, exampleValues: Array<string> }> | null } };

export type GetCsvColumnNumberRangeMutationVariables = Types.Exact<{
  url: Types.Scalars['String']['input'];
  columnName: Types.Scalars['String']['input'];
}>;


export type GetCsvColumnNumberRangeMutation = { __typename?: 'Mutation', getCsvColumnNumberRange: { __typename?: 'GetCsvColumnNumberRangeMutationResult', success: boolean, error?: { __typename?: 'Error', message?: string | null } | null, numberRange?: { __typename?: 'CsvColumnNumberRange', minValue: number, maxValue: number } | null } };

export type MatchOrgGuestFeedbackCsvUploadLocationsMutationVariables = Types.Exact<{
  input: Types.MatchOrgGuestFeedbackCsvUploadLocationsInput;
}>;


export type MatchOrgGuestFeedbackCsvUploadLocationsMutation = { __typename?: 'Mutation', matchOrgGuestFeedbackCsvUploadLocations: { __typename?: 'MatchOrgGuestFeedbackCsvUploadLocationsResult', success: boolean, error?: { __typename?: 'Error', message?: string | null } | null, locationMappings: Array<{ __typename?: 'CsvLocationMapping', locationName: string, locationId?: number | null }> } };

export type LocationsForGuestFeedbackQueryVariables = Types.Exact<{
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type LocationsForGuestFeedbackQuery = { __typename?: 'Query', Locations: { __typename?: 'Locations', totalCount: number, objects: Array<{ __typename?: 'Location', id: number, name: string }> } };

export type GuestFeedbackSourceOptionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GuestFeedbackSourceOptionsQuery = { __typename?: 'Query', OrgGuestFeedbackCsvUploads: { __typename?: 'OrgGuestFeedbackCsvUploads', objects: Array<{ __typename?: 'OrgGuestFeedbackCsvUpload', id: string, feedbackSource?: string | null }> }, OrgGuestFeedbackIntegrations: Array<{ __typename?: 'OrgGuestFeedbackIntegration', id: string, ovationIntegrationConfig?: { __typename?: 'OrgGuestFeedbackOvationIntegrationConfig', id: string } | null, googleBusinessConfig?: { __typename?: 'OrgGuestFeedbackGoogleBusinessConfig', id: string } | null }> };


export const GetCsvColumnsDocument = gql`
    mutation GetCsvColumns($url: String!) {
  getCsvColumns(url: $url) {
    success
    error {
      message
    }
    columns {
      name
      exampleValues
    }
  }
}
    `;
export type GetCsvColumnsMutationFn = Apollo.MutationFunction<GetCsvColumnsMutation, GetCsvColumnsMutationVariables>;

/**
 * __useGetCsvColumnsMutation__
 *
 * To run a mutation, you first call `useGetCsvColumnsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetCsvColumnsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getCsvColumnsMutation, { data, loading, error }] = useGetCsvColumnsMutation({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useGetCsvColumnsMutation(baseOptions?: Apollo.MutationHookOptions<GetCsvColumnsMutation, GetCsvColumnsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetCsvColumnsMutation, GetCsvColumnsMutationVariables>(GetCsvColumnsDocument, options);
      }
export type GetCsvColumnsMutationHookResult = ReturnType<typeof useGetCsvColumnsMutation>;
export type GetCsvColumnsMutationResult = Apollo.MutationResult<GetCsvColumnsMutation>;
export type GetCsvColumnsMutationOptions = Apollo.BaseMutationOptions<GetCsvColumnsMutation, GetCsvColumnsMutationVariables>;
export const GetCsvColumnNumberRangeDocument = gql`
    mutation GetCsvColumnNumberRange($url: String!, $columnName: String!) {
  getCsvColumnNumberRange(url: $url, columnName: $columnName) {
    success
    error {
      message
    }
    numberRange {
      minValue
      maxValue
    }
  }
}
    `;
export type GetCsvColumnNumberRangeMutationFn = Apollo.MutationFunction<GetCsvColumnNumberRangeMutation, GetCsvColumnNumberRangeMutationVariables>;

/**
 * __useGetCsvColumnNumberRangeMutation__
 *
 * To run a mutation, you first call `useGetCsvColumnNumberRangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetCsvColumnNumberRangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getCsvColumnNumberRangeMutation, { data, loading, error }] = useGetCsvColumnNumberRangeMutation({
 *   variables: {
 *      url: // value for 'url'
 *      columnName: // value for 'columnName'
 *   },
 * });
 */
export function useGetCsvColumnNumberRangeMutation(baseOptions?: Apollo.MutationHookOptions<GetCsvColumnNumberRangeMutation, GetCsvColumnNumberRangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetCsvColumnNumberRangeMutation, GetCsvColumnNumberRangeMutationVariables>(GetCsvColumnNumberRangeDocument, options);
      }
export type GetCsvColumnNumberRangeMutationHookResult = ReturnType<typeof useGetCsvColumnNumberRangeMutation>;
export type GetCsvColumnNumberRangeMutationResult = Apollo.MutationResult<GetCsvColumnNumberRangeMutation>;
export type GetCsvColumnNumberRangeMutationOptions = Apollo.BaseMutationOptions<GetCsvColumnNumberRangeMutation, GetCsvColumnNumberRangeMutationVariables>;
export const MatchOrgGuestFeedbackCsvUploadLocationsDocument = gql`
    mutation MatchOrgGuestFeedbackCsvUploadLocations($input: MatchOrgGuestFeedbackCsvUploadLocationsInput!) {
  matchOrgGuestFeedbackCsvUploadLocations(input: $input) {
    success
    error {
      message
    }
    locationMappings {
      locationName
      locationId
    }
  }
}
    `;
export type MatchOrgGuestFeedbackCsvUploadLocationsMutationFn = Apollo.MutationFunction<MatchOrgGuestFeedbackCsvUploadLocationsMutation, MatchOrgGuestFeedbackCsvUploadLocationsMutationVariables>;

/**
 * __useMatchOrgGuestFeedbackCsvUploadLocationsMutation__
 *
 * To run a mutation, you first call `useMatchOrgGuestFeedbackCsvUploadLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatchOrgGuestFeedbackCsvUploadLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matchOrgGuestFeedbackCsvUploadLocationsMutation, { data, loading, error }] = useMatchOrgGuestFeedbackCsvUploadLocationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMatchOrgGuestFeedbackCsvUploadLocationsMutation(baseOptions?: Apollo.MutationHookOptions<MatchOrgGuestFeedbackCsvUploadLocationsMutation, MatchOrgGuestFeedbackCsvUploadLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MatchOrgGuestFeedbackCsvUploadLocationsMutation, MatchOrgGuestFeedbackCsvUploadLocationsMutationVariables>(MatchOrgGuestFeedbackCsvUploadLocationsDocument, options);
      }
export type MatchOrgGuestFeedbackCsvUploadLocationsMutationHookResult = ReturnType<typeof useMatchOrgGuestFeedbackCsvUploadLocationsMutation>;
export type MatchOrgGuestFeedbackCsvUploadLocationsMutationResult = Apollo.MutationResult<MatchOrgGuestFeedbackCsvUploadLocationsMutation>;
export type MatchOrgGuestFeedbackCsvUploadLocationsMutationOptions = Apollo.BaseMutationOptions<MatchOrgGuestFeedbackCsvUploadLocationsMutation, MatchOrgGuestFeedbackCsvUploadLocationsMutationVariables>;
export const LocationsForGuestFeedbackDocument = gql`
    query LocationsForGuestFeedback($pagination: PaginationInput) {
  Locations(pagination: $pagination) {
    objects {
      id
      name
    }
    totalCount
  }
}
    `;

/**
 * __useLocationsForGuestFeedbackQuery__
 *
 * To run a query within a React component, call `useLocationsForGuestFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsForGuestFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsForGuestFeedbackQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useLocationsForGuestFeedbackQuery(baseOptions?: Apollo.QueryHookOptions<LocationsForGuestFeedbackQuery, LocationsForGuestFeedbackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationsForGuestFeedbackQuery, LocationsForGuestFeedbackQueryVariables>(LocationsForGuestFeedbackDocument, options);
      }
export function useLocationsForGuestFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationsForGuestFeedbackQuery, LocationsForGuestFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationsForGuestFeedbackQuery, LocationsForGuestFeedbackQueryVariables>(LocationsForGuestFeedbackDocument, options);
        }
export type LocationsForGuestFeedbackQueryHookResult = ReturnType<typeof useLocationsForGuestFeedbackQuery>;
export type LocationsForGuestFeedbackLazyQueryHookResult = ReturnType<typeof useLocationsForGuestFeedbackLazyQuery>;
export type LocationsForGuestFeedbackQueryResult = Apollo.QueryResult<LocationsForGuestFeedbackQuery, LocationsForGuestFeedbackQueryVariables>;
export const GuestFeedbackSourceOptionsDocument = gql`
    query GuestFeedbackSourceOptions {
  OrgGuestFeedbackCsvUploads {
    objects {
      id
      feedbackSource
    }
  }
  OrgGuestFeedbackIntegrations {
    id
    ovationIntegrationConfig {
      id
    }
    googleBusinessConfig {
      id
    }
  }
}
    `;

/**
 * __useGuestFeedbackSourceOptionsQuery__
 *
 * To run a query within a React component, call `useGuestFeedbackSourceOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestFeedbackSourceOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestFeedbackSourceOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGuestFeedbackSourceOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GuestFeedbackSourceOptionsQuery, GuestFeedbackSourceOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuestFeedbackSourceOptionsQuery, GuestFeedbackSourceOptionsQueryVariables>(GuestFeedbackSourceOptionsDocument, options);
      }
export function useGuestFeedbackSourceOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuestFeedbackSourceOptionsQuery, GuestFeedbackSourceOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuestFeedbackSourceOptionsQuery, GuestFeedbackSourceOptionsQueryVariables>(GuestFeedbackSourceOptionsDocument, options);
        }
export type GuestFeedbackSourceOptionsQueryHookResult = ReturnType<typeof useGuestFeedbackSourceOptionsQuery>;
export type GuestFeedbackSourceOptionsLazyQueryHookResult = ReturnType<typeof useGuestFeedbackSourceOptionsLazyQuery>;
export type GuestFeedbackSourceOptionsQueryResult = Apollo.QueryResult<GuestFeedbackSourceOptionsQuery, GuestFeedbackSourceOptionsQueryVariables>;